import type { components } from "@/api-schema";

export enum UserNamePart {
  FirstName,
  LastName,
}

type UserNameParts = Pick<components["schemas"]["User"], "firstName" | "lastName">;

type GetFullUserNameOptions = {
  user: UserNameParts;
  startingPart?: UserNamePart;
  separator?: string;
};

export function getFullUserName(options: GetFullUserNameOptions): string {
  const { user, startingPart = UserNamePart.FirstName, separator = " " } = options;

  const orderedUserNameParts =
    startingPart === UserNamePart.FirstName ? [user.firstName, user.lastName] : [user.lastName, user.firstName];

  return orderedUserNameParts.filter(Boolean).join(separator);
}
